import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SignupService, AlertService, GeographyService } from '@app/_services';
import { EmptyStringValidator } from '@app/_helpers';
import { Signup, natureOfBusinesses } from '@app/_models';
import { SignupComponent } from '../signup.component';
import { AppComponent } from '@app/app.component';

@Component({ templateUrl: 'start.component.html' })

export class StartComponent implements OnInit {
  form: UntypedFormGroup;
  loading = false;
  submitted = false
  submitDisabled = true;
  signup: Signup;
  natureOfBusiness = natureOfBusinesses;
  getOtherNatureofBusiness: boolean = false;
  firstNameInvalid: boolean;
  lastNameInvalid: boolean;
  companyNameInvalid: boolean;
  clientnatureofbusinessInvalid: boolean;
  othernatureofbusinessInvalid: boolean;
  phoneNumberInvalid: boolean;
  emailInvalid: boolean;
  billToZipInvalid: boolean;
  clientPartnerID: number;
  userLostSession: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private signupService: SignupService,
    private geographyService: GeographyService,
    private alertService: AlertService,
    @Inject(SignupComponent) private signupComponent: SignupComponent,
    @Inject(AppComponent) private appComponent: AppComponent) { this.signup = this.signupService.getSignup(); }

  ngAfterViewInit(): void {
    if (this.signupComponent.freeBackground || (this.signup.freeBackground === false)) {
      this.alertService.success("Complete the sign-up process to redeem your free background!", { autoClose: false })

      if (this.signupComponent.campaignToken !== undefined) {
        this.signup.campaignToken = this.signupComponent.campaignToken;
      }
    }
    if (this.form.valid) {
      this.submitDisabled = false;
    }
    if (this.signup.othernatureofbusiness) {
      this.form.patchValue({ clientnatureofbusiness: 'Other', othernatureofbusiness: this.signup.othernatureofbusiness })
      this.toggleNatureOfBusiness(true);
    }
  }
  ngOnInit() {
    this.loading = false;
    this.firstNameInvalid = false;
    this.lastNameInvalid = false;
    this.companyNameInvalid = false;
    this.clientnatureofbusinessInvalid = false;
    this.othernatureofbusinessInvalid = false;
    this.phoneNumberInvalid = false;
    this.emailInvalid = false;
    this.billToZipInvalid = false;
    this.clientPartnerID = 1;
    //check to see if the user session was last at submission and if the user was redirected to the start page
    this.checkIfRedirectedFromAccountSubmission(this.appComponent.lostSession);
    this.form = this.formBuilder.group({
      numberOfEmployees: [this.signup.numberOfEmployees, [Validators.required]],
      firstName: [this.signup.firstName, [Validators.required, Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'), EmptyStringValidator]],
      lastName: [this.signup.lastName, [Validators.required, Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'), EmptyStringValidator]],
      email: [this.signup.email, [Validators.required, Validators.email]],
      companyName: [this.signup.companyName, [Validators.required, EmptyStringValidator]],
      clientnatureofbusiness: [this.signup != null && this.signup.clientnatureofbusiness != undefined ? this.signup.clientnatureofbusiness : '', [Validators.required]],
      othernatureofbusiness: [''],
      phoneNumber: [this.signup.phoneNumber, [Validators.required, Validators.minLength(10), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      billToZip: [this.signup.billToZip, [Validators.required, Validators.minLength(5), Validators.pattern(/^-?(|[0-9]\d*)?$/)]],
      partnerID: 1
    });

  }

  noWhitespaceValidator(control: UntypedFormControl) {
    const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  toggleNatureOfBusiness(isOther: boolean) {
    if (this.form) {
      if (isOther) {
        this.form.controls.othernatureofbusiness.addValidators([Validators.required, EmptyStringValidator]);
      } else {
        this.form.controls.othernatureofbusiness.removeValidators([Validators.required, EmptyStringValidator]);
      }
      this.getOtherNatureofBusiness = isOther;
      this.form.controls.othernatureofbusiness.updateValueAndValidity();
    }
  }

  checkIfRedirectedFromAccountSubmission(wasRedirected: boolean) {
    if (wasRedirected) {
      this.alertService.error('Your session storage was lost. Please re-enter your information to proceed');
      this.signupComponent.currentStep = 0;
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onCancel() {
    sessionStorage.clear();
    this.router.navigate(['/account/login'])
  }

  onSubmit() {
    this.submitted = true;
    this.loading = true;

    // reset alerts on submit
    this.alertService.clear();

    if (this.form.invalid) {
      this.alertService.error("Please ensure your provided information is correct")
      this.loading = false;
      return;
    }

    if (this.getOtherNatureofBusiness) {
      this.form.patchValue({ clientnatureofbusiness: this.form.controls.othernatureofbusiness.value });
    }

    this.geographyService.lookupState(this.form.value.billToZip).subscribe(state => {

      if (state.code == undefined) {
        this.alertService.error("Make sure your zip code is valid!");
        this.loading = false;
        return;
      }
      else {
        this.signupService.insertSMBClient(this.form.value).subscribe(response => {
          if (response === 0) {
            this.loading = false;
            this.alertService.error('An account exists with this email address. Please try <a href="/account/login">logging in.</a>')
          }
          else if (response == -1) {
            this.loading = false;
            this.alertService.error('Account exists on EASE platform. Please contact Customer Service.')
          }
          else {
            this.form.value.ID = response
            this.signupService.saveStart(this.form.value, state.code);
            this.signupComponent.startStep.visited = true;
            this.router.navigate(['/signup/package']);
          }
        })
      }
    });
  }

  showValidation(field: string) {
    if (this.form.controls[field].invalid) {
      this[field + "Invalid"] = true;
    }
    else {
      this[field + "Invalid"] = false;
    }
  }

}
